<template>
  <div class="container text-secondary">

    <div class="row mb-4">
      <div class="col text-center">
        <img src="@/assets/pencil.svg" alt="" class="img-fluid d-inline-block opacity-75" style="height:40px;"/>
        <div class="h2 d-inline-block ms-2">Scoreblokje</div>
      </div>
    </div>

    <hr class="divider">

    <!-- Speel een spel -->
    <div class="hoofd-kaart mb-3" @click="$router.push('/spelen')">
      <img src="@/assets/cards-100.png" alt="" class="hoofd-icoon"/>
      <div class="hoofd-tekst">
        <div class="hoofd-titel">Speel een spel</div>
        <div class="hoofd-sub">Kies een spel, stel de tafel in en begin</div>
      </div>
      <span class="hoofd-pijl">›</span>
    </div>

    <!-- Spelers beheren -->
    <div class="beheer-kaart" @click="$router.push('/lounge')">
      <img src="@/assets/crowd-100.png" alt="" class="beheer-icoon"/>
      <div class="beheer-tekst">
        <div class="beheer-titel">Spelers beheren</div>
        <div class="beheer-sub">
          {{ players.length === 0 ? 'Nog geen spelers' : `${players.length} speler${players.length === 1 ? '' : 's'}` }}
        </div>
      </div>
      <span class="hoofd-pijl" style="color:#cbd5e0;">›</span>
    </div>

  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "MainScreen",
  computed: {
    players() {
      return store.state.players;
    },
  },
}
</script>

<style scoped>
.hoofd-kaart {
  display: flex;
  align-items: center;
  gap: 16px;
  background: white;
  border-radius: 16px;
  padding: 20px 16px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border: 2px solid #e2e8f0;
}
.hoofd-kaart:hover {
  border-color: #667eea;
  box-shadow: 0 4px 12px rgba(102,126,234,0.15);
  transform: translateY(-1px);
}
.hoofd-icoon {
  height: 56px;
  width: 56px;
  object-fit: contain;
}
.hoofd-tekst { flex: 1; }
.hoofd-titel {
  font-size: 1.2rem;
  font-weight: 800;
  color: #2d3748;
}
.hoofd-sub {
  font-size: 0.85rem;
  color: #a0aec0;
  margin-top: 2px;
}
.hoofd-pijl {
  font-size: 1.8rem;
  color: #667eea;
}
.beheer-kaart {
  display: flex;
  align-items: center;
  gap: 16px;
  background: white;
  border-radius: 16px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border: 2px solid transparent;
}
.beheer-kaart:hover {
  border-color: #e2e8f0;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transform: translateY(-1px);
}
.beheer-icoon {
  height: 48px;
  width: 48px;
  object-fit: contain;
}
.beheer-tekst { flex: 1; }
.beheer-titel {
  font-size: 1rem;
  font-weight: 700;
  color: #2d3748;
}
.beheer-sub {
  font-size: 0.85rem;
  color: #a0aec0;
  margin-top: 2px;
}
</style>